import ManagersContext from '../../containers/ManagersContext'
import {ReactNode, useContext} from 'react'
interface iPublinkProps {
    pubkey: string,
    children: ReactNode
}

function Publink (props: iPublinkProps) {
  const {docsManager} = useContext(ManagersContext)
  return (
    <a href={docsManager.get(props.pubkey)}
      target='_BLANK'
      rel="noreferrer">{props.children}</a>
  )
}
export default Publink
